import { ReactNode } from 'react'

type Props = {
  title: string
  children: ReactNode
}

const SitemapLinksContainer = ({ title, children }: Props) => {
  return (
    <div className="">
      <h2 className="font-semibold text-tella-blue-300">{title}</h2>
      <div className="ml-3 mt-3 grid items-start gap-3 sm:grid-cols-2 md:grid-cols-3">{children}</div>
    </div>
  )
}

export default SitemapLinksContainer
